import React, { useEffect, useState,useRef } from "react";
import Container from "common/components/Container/Container";
import i18n from "internationalization/i18n";
import { useDispatch, useSelector } from "react-redux";
import { rootReducerType } from "../../redux/combineReducers";
import useWindowDimensions, { counterCommonItemsArrays, decodeJWT, getDataToDisplay } from "../../common/functions";
import { emailToUsername, getUpperCase } from "../../common/utils";
import {
	transactionsApi,
	useGetTransactionsQuery,
	useFefundTransactionMutation
} from "../../services/transactionsService";
import { Button, DatePicker, Space, Modal, Input, InputNumber, Form } from "antd";
import SelectFilter from "../../common/components/Select/Select";
import { useGetStationsQuery } from "../../services/stationsService";
import TransactionsTable
	from "../../common/components/TransactionsTable/TransactionsTable";
import moment from "moment";
import { formatISO8601 } from "common/constants";
import { TransactionItem } from "services/utils/interfaces";
import Notification from "common/components/NotificationMessage/Notification";
import "./Transactions.less"
import { log } from "console";
import { useGetMenuQuery } from "services/dashboardService";

const { RangePicker } = DatePicker;

type Props = {
	shouldRefresh: boolean,
};

type FilterDates = {
	startTime?: string,
	endTime?: string,
};

export type Transactions = Array<TransactionItem>;

const Transactions: React.FC<Props> = ({ shouldRefresh }): React.ReactElement => {

	const { isLoggedIn } = useSelector((state: rootReducerType) => state.authenticationReducer);

	const dispatch = useDispatch();

	const getFilterBy = (filter: string | null): string | undefined =>
		filter && [i18n.t("transactions.station"), i18n.t("transactions.type")].includes(filter)
			? filter
			: undefined;

	const getFilterQueryString = (key: string | null, filterValue: string | null) =>
		key && filterStation(filterValue)
			? key?.toLowerCase() + "_is_" + filterStation(filterValue)
			: undefined;

	const getKey = (filterBy?: string): string | null =>
		filterBy
			? (filterBy === i18n.t("transactions.station") ? "stationId"
				: (filterBy === i18n.t("transactions.type")
					? "type"
					: null))
			: null;

	const getDates = (startTime: string | null, endTime: string | null): FilterDates => {
		let startDate: string | undefined;
		let endDate: string | undefined;
		if (startTime && endTime) {
			startDate = moment(startTime).startOf("day").format('YYYY-MM-DDTHH:mm:ss');
			endDate = moment(endTime).endOf("day").format('YYYY-MM-DDTHH:mm:ss');
		}
		return { startTime: startDate, endTime: endDate };
	};

	const { stations1 } = useSelector(
		(state: rootReducerType) => state.stationsReducer
	);
	const menuData = useGetMenuQuery(stations1).data

	const filterStation = (stationId: any) => {
		if (filter !== "Station") return stationId;
		if (menuData && stationId) {
			const menfil = menuData[0].Dashboard.filter((item) => {
				if(item != "All") {
					return item
				}
			})
			const menuFind = menfil.find((item) => {
				return item.stationName == stationId
			})

			return menuFind['locationId.stationId']
		}
	}

	const [stationData, setStationData] = useState<any>([])

	const filterStationData = () => {
		if (menuData) {
			const menuFil = menuData[0].Dashboard.filter((item) => {
				if(item !== "All") {
					return item
				}
			})

			return menuFil.map((item) => {
				return item.stationName
			})
		}
	}


	const [limit] = useState(10);
	const [offset, setOffset] = useState<number>(0);
	const [previousOffset, setPreviousOffset] = useState<number>(offset);

	const [startTime, setStartTime] = useState<string | null>(null);
	const [endTime, setEndTime] = useState<string | null>(null);
	const [sort, setSort] = useState<string | null>(null);
	const [filter, setFilter] = useState<string | null>(null);
	const [filterValue, setFilterValue] = useState<string | null>(null);
	const [reset, setReset] = useState(false);
	const [dateRange, setDateRange] = useState<Array<moment.Moment> | undefined>(undefined);
	const [isOpenRangePicker, setIsOpenRangePicker] = useState<boolean>(false);

	const [transactions, setTransactions] = useState<Transactions>([]);

	const selectItems = [{ option: i18n.t("transactions.station") }, { option: i18n.t("transactions.type") }];
	const typeData = [i18n.t("transactions.level2"), i18n.t("transactions.dcfc")];
	const stations = useGetStationsQuery({
		userName: emailToUsername(decodeJWT(isLoggedIn).email)
	}).data;
	// const stationData = stations ? Object.keys(stations) : [];

	useEffect(() => {
		setStationData(filterStationData()) 
	}, [menuData])

	const { data, refetch } = useGetTransactionsQuery({
		userName: emailToUsername(decodeJWT(isLoggedIn).email),
		limit: String(limit),
		offset: String(offset < 0 ? 0 : offset),
		sortBy: sort ? sort : undefined,
		filterBy: getFilterQueryString(getKey(getFilterBy(filter)), filterValue),
		...getDates(startTime, endTime)
	});
 
	const [feFundTransaction, { isSuccess, data: refundMessageData }] = useFefundTransactionMutation();

	// const data = "111"

	const { width } = useWindowDimensions();
	const dateFormat = "MMM D, YYYY";
	const dateFormatParams = 'YYYY-MM-DDTHH:mm:ss';

	const setRange = (values) => {
		setDateRange(values);
	};

	useEffect(() => {
		if (offset < previousOffset) return;
		if (offset === previousOffset) {
			const tempOffset = offset < 0 ? 0 : offset;
			setOffset(tempOffset);
			setPreviousOffset(tempOffset);
			const filterBy = getFilterBy(filter);
			const key = getKey(filterBy);
			dispatch(
				transactionsApi.endpoints.getTransactions.initiate(
					{
						userName: emailToUsername(decodeJWT(isLoggedIn).email),
						limit: String(limit),
						offset: String(tempOffset),
						sortBy: sort ? sort : undefined,
						filterBy: getFilterQueryString(key, filterValue),
						...getDates(startTime, endTime)
					},
					{ subscribe: false, forceRefetch: true }
				)
			);
		}

		// setReset(false);
	}, [offset]);

	useEffect(() => {
		const tempOffset = offset <= 0 ? offset - 1 : 0;
		setOffset(tempOffset);
		setPreviousOffset(tempOffset);
	}, [startTime, endTime, filterValue, sort]);

	useEffect(() => {
		if (!data?.items) return;

		const tempOffset = offset < 0 ? 0 : offset;
		setOffset(tempOffset);
		setPreviousOffset(tempOffset);

		const counterCommonItems = counterCommonItemsArrays(data.items, transactions);

		const newItems = JSON.parse(JSON.stringify(
			offset <= 0
				? [...data.items]
				: (counterCommonItems === 0
					? [...transactions, ...data.items]
					: [...transactions]
				)));

		setTransactions(newItems);
		setPreviousOffset(offset);
	}, [JSON.stringify(data?.items), offset, reset]);

	useEffect(() => {
		if (!reset) {
			setReset(false);

		}
		refetch();
	}, [refetch, reset]);

	useEffect(() => {
		refetch();
	}, [shouldRefresh]);
 
	useEffect(() => {
		if (!isOpenRangePicker) {
			setStartTime(dateRange ? moment(dateRange?.[0])?.format(dateFormatParams) : null);
			setEndTime(dateRange ? moment(dateRange?.[1])?.format(dateFormatParams) : null);
		}
	}, [isOpenRangePicker]);

	const handleReset = () => {
		const tempOffset = offset <= 0 ? offset - 1 : 0;
		setReset(true);
		setFilter(null);
		setFilterValue(null);
		setSort(null);
		setEndTime(null);
		setStartTime(null);
		setDateRange(undefined);
		setOffset(tempOffset);
		setPreviousOffset(tempOffset);
	};

	const [isModalOpen, setIsModalOpen] = useState(false);

	const showModal = () => {
		setIsModalOpen(true);
	};

	const handleOk = (e) => {
		setIsModalOpen(false);
		let refundParamsAll = {...refundParams, ...e}
		if (refundParams) {
			feFundTransaction(refundParamsAll)
		}
	};

	const [refundParams, setRefundParams] = useState<any>(null)

	const handleCancel = () => {
		setIsModalOpen(false);
	};

	useEffect(() => {
		if(isSuccess) {
            Notification({ 
                type: refundMessageData?.success ? "success" : "warning",
                message: refundMessageData?.success ? refundMessageData.message : "request error", 
                description: "" 
            });
            refetch()
        }
	}, [isSuccess])

	function onChange(value) {
	}

	const { TextArea } = Input;

	const [refundMessage, setRefundMessage] = useState("");

	const formRef = useRef<any>(null);

	const [refundMax, setRefundMax] = useState<number>(10);

	return (width > 768 ?
		(<Container
			backButton={false}
			loadingPageName={i18n.t("transactions.pageName")}
			subTitle={i18n.t("transactions.subtitle")}
			renderCondition={data ? true : false}
		>
			<div className="table">
				<div className="sessions-title">
					<div>
						<RangePicker
							onChange={setRange}
							format={dateFormat}
							open={isOpenRangePicker}
							value={reset || !dateRange ? undefined : [dateRange && moment(dateRange[0]), dateRange && moment(dateRange[1])]}
							onOpenChange={setIsOpenRangePicker}
						/>
						<SelectFilter
							selectedFilter={filter || undefined}
							selectedFilterValue={filterValue || undefined}
							setNewFilter={(value) => setFilter(value)}
							setNewFilterValue={(value) => setFilterValue(value)}
							items={selectItems}
							statusData={stationData}
							typeData={typeData}
							stationData={stationData}
							reset={reset}
							setReset={setReset}
						/>
					</div>
					<Button onClick={handleReset} className="dark-button">{i18n.t("transactions.resetFilters")}</Button>
				</div>
				{data ?
					(<TransactionsTable
						limit={limit}
						offset={offset < 0 ? 0 : offset}
						setOffset={setOffset}
						length={transactions.length + (transactions.length < limit ? 0 : 1)}
						data={getDataToDisplay(transactions, limit, offset)}
						setNewSort={(value) => setSort(value)}
						shouldReset={(value) => setReset(value)}
						reset={reset}
						setTransactions={setTransactions}
						setReset={setReset}
						transactions={transactions}
						setRefundParams={setRefundParams}
						setIsModalOpen={setIsModalOpen}
						setRefundMax={setRefundMax}
					/>) :
					null}
			</div>
			<Modal title="" visible={isModalOpen} onOk={handleOk} onCancel={handleCancel}
				footer={null}>
				<div style={{
					height: '100px', fontWeight: 'bold', fontSize: '30px',
					display: 'flex', alignItems: 'center', justifyContent: 'center'
				}}>Refund this transaction</div>
				<div className="model-content model-content-transtions">
					<Form
						initialValues={{ email: '' }}
						onFinish={handleOk}
						autoComplete="off"
						ref={formRef}>
						<div className="model-content-item3">
							<p>refund amount: </p>
							<Form.Item
								label=""
								name="refundAmount"
								rules={[{ required: true, message: 'Please select your refund amount!' }]}>
								<InputNumber min={1} max={refundMax} onChange={onChange}
									style={{ width: '260px' }} />
							</Form.Item>
						</div>

						<div className="model-content-item">
							<p>refund message: </p>
							<Form.Item
								label=""
								name="refundMessage">
								<TextArea rows={4} style={{ width: '260px' }} />
							</Form.Item>
							
						</div>

						<div className="model-buttons">
							<Form.Item style={{width: '45%'}}>
								<Button size="large" type="primary" danger onClick={handleCancel}
								style={{width: '100%', margin: '0 auto'}}>NO</Button>
							</Form.Item>
							<Form.Item style={{width: '45%'}}>
								<Button size="large" type="primary" htmlType="submit"
								style={{width: '100%'}}>YES</Button>
							</Form.Item>
						</div>
					</Form>
				</div>
			</Modal>
		</Container>) : (<Container
			backButton={false}
			loadingPageName={i18n.t("transactions.pageName")}
			subTitle={i18n.t("transactions.subtitle")}
			renderCondition={data ? true : false}
			styleNoFlex={true}
		>
			<div style={{ display: "flex", flexDirection: "row" }}>
				<Button onClick={handleReset} className="dark-button">Reset filters</Button>
				<div style={{ marginTop: "auto", marginBottom: "auto" }}>
					<SelectFilter
						selectedFilter={filter || undefined}
						selectedFilterValue={filterValue || undefined}
						setNewFilter={(value) => setFilter(value)}
						setNewFilterValue={(value) => setFilterValue(value)}
						items={selectItems}
						statusData={[]}
						typeData={typeData}
						stationData={stationData}
						reset={reset}
						setReset={setReset}
					/>
				</div>
			</div>
			<Space style={{ marginBottom: "16px" }} direction="vertical" size={12}>
				<RangePicker onChange={setRange} format={dateFormat} value={reset || !dateRange ? undefined : [dateRange && moment(dateRange[0]), dateRange && moment(dateRange[1])]} />
			</Space>

			{data ?
				(<div className="table">
					<TransactionsTable
						limit={limit}
						offset={offset < 0 ? 0 : offset}
						setOffset={setOffset}
						length={transactions.length + (data?.items.length < limit ? 0 : 1)}
						data={getDataToDisplay(transactions, limit, offset)}
						setNewSort={(value) => setSort(value)}
						shouldReset={(value) => setReset(value)}
						reset={reset}
						setTransactions={setTransactions}
						setReset={setReset}
						transactions={transactions}
						setRefundParams={setRefundParams}
						setIsModalOpen={setIsModalOpen}
						setRefundMax={setRefundMax}
					/>
				</div>) :
				null}
			<Modal title="" visible={isModalOpen} onOk={handleOk} onCancel={handleCancel}
				footer={null}>
				<div style={{
					height: '100px', fontWeight: 'bold', fontSize: '30px',
					display: 'flex', alignItems: 'center', justifyContent: 'center'
				}}>Refund this transaction</div>
				<div className="model-content model-content-transtions">
					<Form
						initialValues={{ email: '' }}
						onFinish={handleOk}
						autoComplete="off"
						ref={formRef}>
						<div className="model-content-item3">
							<p>refund amount: </p>
							<Form.Item
								label=""
								name="refundAmount"
								rules={[{ required: true, message: 'Please select your refund amount!' }]}>
								<InputNumber min={1} max={refundMax} onChange={onChange}
									style={{ width: '260px' }} />
							</Form.Item>
						</div>

						<div className="model-content-item">
							<p>refund message: </p>
							<Form.Item
								label=""
								name="refundMessage">
								<TextArea rows={4} style={{ width: '260px' }} />
							</Form.Item>
							
						</div>

						<div className="model-buttons">
							<Form.Item style={{width: '45%'}}>
								<Button size="large" type="primary" danger onClick={handleCancel}
								style={{width: '100%', margin: '0 auto'}}>NO</Button>
							</Form.Item>
							<Form.Item style={{width: '45%'}}>
								<Button size="large" type="primary" htmlType="submit"
								style={{width: '100%'}}>YES</Button>
							</Form.Item>
						</div>
					</Form>
				</div>
			</Modal>
		</Container>)
	);
};

export default Transactions;
